module.exports = __webpack_public_path__ + "static/img/foot_top.e4ec3f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/foot_top.png
// module id = hIoR
// module chunks = 17